<template>

  <Modal
    :title="$t('Actions')"
    @close="cancel"
    min-height="300px"
    max-width="640px">
    <template slot="body">

      <ul class="nav nav-tabs mb-3">
        <li class="nav-item">
          <a
            class="nav-link "
            href="javascript:void(0)"
            @click="changeTrigger('enter')"
            :class="{ active: trigger === 'enter' }">Ao entrar na etapa ({{ totals.enter }})</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="javascript:void(0)"
            @click="changeTrigger('disqualify')"
            :class="{ active: trigger === 'disqualify' }">Ao desclassificar ({{ totals.disqualify }})</a>
        </li>
      </ul>

      <div
        v-for="(action, index) in actions"
        :key="index">
        <div v-if="action.trigger === trigger">
          <div
            v-if="action.type === 'email'"
            class="card mb-2">
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <div class="mr-auto">E-mail</div>
                <div><a href="javascript:void(0)" class="text-secondary" @click="removeAction(index)"><i class="far fa-trash-alt" /></a></div>
              </div>
            </div>
            <div class="card-body">
              <div class="form-group">
                <label>{{ $t('Template') }}</label>
                <SelectTemplatemail
                  v-model="action.templatemail_id" />
                <ValidateMessage :error="validateErrors[`actions.${index}.templatemail_id`]" />
              </div>
              <div class="form-group mb-0">
                <label>{{ $t('Delay') }}</label>
                <DelayRelativeForm
                  v-model="action.delay" />
                <ValidateMessage :error="validateErrors[`actions.${index}.delay`]" />
                <ValidateMessage :error="validateErrors[`actions.${index}.delay.due_time`]" />
              </div>
            </div>
          </div>
          <div
            v-if="action.type === 'questionnaire'"
            class="card mb-2">
            <div class="card-header">
            <div class="d-flex justify-content-between">
                <div class="mr-auto">{{ $t('Questionnaire') }}</div>
                <div><a href="javascript:void(0)" class="text-secondary" @click="removeAction(index)"><i class="far fa-trash-alt" /></a></div>
              </div>
            </div>
            <div class="card-body">
              <div class="form-group">
                <label>{{ $t('Template') }}</label>
                <SelectQuestionform
                  v-model="action.questionform_id" />
                  <ValidateMessage :error="validateErrors[`actions.${index}.questionform_id`]" />
              </div>
              <div class="form-group mb-0">
                <label>{{ $t('Delay') }}</label>
                <DelayRelativeForm
                  v-model="action.delay" />
                  <ValidateMessage :error="validateErrors[`actions.${index}.delay`]" />
                  <ValidateMessage :error="validateErrors[`actions.${index}.delay.due_time`]" />
              </div>
            </div>
          </div>
          <div
            v-if="action.type === 'intervideo'"
            class="card mb-2">
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <div class="mr-auto">Intervideo</div>
                <div><a href="javascript:void(0)" class="text-secondary" @click="removeAction(index)"><i class="far fa-trash-alt" /></a></div>
              </div>
            </div>
            <div class="card-body">
              <div class="form-group">
                <label>{{ $t('Template') }}</label>
                <SelectVideoform
                  v-model="action.videoform_id" />
                  <ValidateMessage :error="validateErrors[`actions.${index}.videoform_id`]" />
              </div>
              <div class="form-group mb-0">
                <label>{{ $t('Delay') }}</label>
                <DelayRelativeForm
                  v-model="action.delay" />
                  <ValidateMessage :error="validateErrors[`actions.${index}.delay`]" />
                  <ValidateMessage :error="validateErrors[`actions.${index}.delay.due_time`]" />
              </div>
            </div>
          </div>
          <div
            v-if="action.type === 'task'"
            class="card mb-2">
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <div class="mr-auto">Task</div>
                <div><a href="javascript:void(0)" class="text-secondary" @click="removeAction(index)"><i class="far fa-trash-alt" /></a></div>
              </div>
            </div>
            <div class="card-body">
              <div class="form-group">
                <label>{{ $t('Comment') }}</label>
                <textarea
                  class="form-control"
                  type="text"
                  placeholder=""
                  v-model="action.task_comment"></textarea>
                  <ValidateMessage :error="validateErrors[`actions.${index}.task_comment`]" />
              </div>
              <div class="form-group">
                <label>{{ $t('Assigned type') }}</label>
                <select
                  class="form-control"
                  v-model="action.task_assigned_type">
                  <option value="author">{{ $t('Author') }}</option>
                  <option value="fixed">{{ $t('Fixed') }}</option>
                </select>
                <ValidateMessage :error="validateErrors[`actions.${index}.task_assigned_type`]" />
              </div>
              <div
                v-if="action.task_assigned_type === 'fixed'"
                class="form-group">
                <label>{{ $t('User') }}</label>
                <SelectUser
                  v-model="action.task_assigned_user_id" />
                  <ValidateMessage :error="validateErrors[`actions.${index}.task_assigned_user_id`]" />
              </div>
              <div class="form-group mb-0">
                <label>{{ $t('Delay') }}</label>
                <DelayRelativeForm
                  v-model="action.delay" />
                  <ValidateMessage :error="validateErrors[`actions.${index}.delay`]" />
                  <ValidateMessage :error="validateErrors[`actions.${index}.delay.due_time`]" />
              </div>
            </div>
          </div>
          <div
            v-if="action.type === 'tag'"
            class="card mb-2">
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <div class="mr-auto">Tag</div>
                <div><a href="javascript:void(0)" class="text-secondary" @click="removeAction(index)"><i class="far fa-trash-alt" /></a></div>
              </div>
            </div>
            <div class="card-body">
              <div class="form-group mb-0">
                <label>{{ $t('Tags') }}</label>
                <SelectTags
                  v-model="action.tags" />
                <ValidateMessage :error="validateErrors[`actions.${index}.tags`]" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-group" role="group">
        <button
          class="btn btn-secondary dropdown-toggle"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          {{ $t('Add action') }}
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            type="button"
            class="dropdown-item"
            @click="addAction('email')">
              E-mail
            </button>
          <button
            type="button"
            class="dropdown-item"
            @click="addAction('task')">
              Task
            </button>
          <button
            type="button"
            class="dropdown-item"
            @click="addAction('questionnaire')">
              {{ $t('Questionnaire') }}
              </button>
          <!-- <button
            type="button"
            class="dropdown-item"
            @click="addAction('intervideo')">
              Intervideo
            </button> -->
          <button
            type="button"
            class="dropdown-item"
            @click="addAction('tag')">
              Tag
            </button>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="button"
          class="btn btn-light"
          @click="cancel">{{ $t('Cancel') }}</button>
        <button
          type="button"
          class="btn btn-primary"
          @click="updateActions">{{ $t('Save') }}</button>
      </div>
    </template>
  </Modal>

</template>

<script>
import Modal from '@/components/Modal/Modal'
import SelectTemplatemail from '@/components/Fields/SelectTemplatemail'
import SelectQuestionform from '@/components/Fields/SelectQuestionform'
import SelectVideoform from '@/components/Fields/SelectVideoform'
import SelectTags from '@/components/Fields/SelectTags'
import DelayRelativeForm from '@/components/Parts/DelayRelativeForm'
import SelectUser from '@/components/Fields/SelectUser'

export default {
  name: 'StageActionForm',
  components: {
    Modal,
    SelectTemplatemail,
    SelectQuestionform,
    SelectTags,
    SelectVideoform,
    DelayRelativeForm,
    SelectUser
  },
  props: {
    value: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      trigger: 'enter',
      loading: false,
      actions: this.$clone(this.value || []),
      validateErrors: {}
    }
  },
  computed: {
    totals () {
      return {
        enter: this.actions.filter(action => action.trigger === 'enter').length,
        disqualify: this.actions.filter(action => action.trigger === 'disqualify').length
      }
    }
  },
  created () {
  },
  methods: {
    changeTrigger (trigger) {
      this.validate(this.actions, this.trigger, () => {
        this.trigger = trigger
      })
    },
    addAction (type) {
      this.actions.push({
        type: type,
        trigger: this.trigger
      })
    },
    removeAction (index) {
      this.actions.splice(index, 1)
    },
    /*
    cancel
    */
    cancel () {
      this.$emit('cancel')
    },
    /*
    updateStage
    */
    updateActions () {
      this.validate(this.actions, this.trigger, () => {
        this.$emit('input', this.actions)
      })
    },
    validate (actions, trigger, callback) {
      this.loading = true
      this.axios.post('/accounts/' + this.$store.getters.getAccount._id + '/stages/validate-actions', {
        actions,
        trigger
      }).then(() => {
        this.loading = false
        callback()
      }).catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal{
  display: block;
  background: rgb(0,0,0,0.7);
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Stage/StageActionForm.vue